var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tabs',{attrs:{"type":"border-card"}},[_c('el-tab-pane',{attrs:{"label":"供应商管理"}},[_c('Supplier')],1),_c('el-tab-pane',{attrs:{"label":"商品信息管理"}},[_c('Merchandise')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }